'use client';

import { useState } from 'react';
import pricing from '../config/pricing';
import PremiumSignupActions from './PremiumSignupActions';
import { useLandingAccount } from '../../lib/landingAccount';
import { usePremiumOfferImpression } from '../../lib/premiumOfferImpression';

export default function HeroPremiumOffer({ home, locale }) {
  const [billingInterval, setBillingInterval] = useState('monthly');
  const account = useLandingAccount();
  const offerRef = usePremiumOfferImpression({ ctaLocation: 'hero', billingInterval, locale });
  // Wait for a confirmed free plan before offering an upgrade to a member.
  if (account?.kind === 'registered' && account.isPremium !== false) return null;
  const annual = billingInterval === 'annual';
  const money = new Intl.NumberFormat(locale, { style: 'currency', currency: pricing.currency });
  const annualMonthly = money.format(Number(pricing.annualProMonthlyPrice));
  const annualTotal = money.format(Number(pricing.annualProTotalPrice));
  const monthly = money.format(Number(pricing.monthlyProPrice));

  return <aside ref={offerRef} className="hero-premium" aria-label="Premium">
    <div className="hero-premium__heading"><strong>Premium</strong><span>{home.heroPremiumBenefit}</span></div>
    <div className="hero-premium__billing" role="group" aria-label={home.billingToggleLabel}>
      <button type="button" aria-pressed={!annual} onClick={() => setBillingInterval('monthly')}>{home.billingMonthly}</button>
      <button type="button" aria-pressed={annual} onClick={() => setBillingInterval('annual')}>{home.billingAnnual}</button>
    </div>
    <p className="hero-premium__annual" aria-live="polite"><strong>{annual ? annualMonthly : monthly}</strong><span>{home.billingPerMonth} · {annual ? home.heroPremiumAnnual.replace('${annualTotal}', annualTotal) : home.billingMonthlyDetail}</span></p>
    <div className="hero-premium__details"><span>{home.heroPremiumLimits}</span></div>
    <PremiumSignupActions locale={locale} billingInterval={billingInterval} ctaLocation="hero" compareHref="#pricing" />
  </aside>;
}
